var exports = {
  "container": "xa15a2ab7--e9c226--container",
  "container--fullscreen": "xa15a2ab7--e9c226--container--fullscreen",
  "image": "xa15a2ab7--e9c226--image",
  "service-logo": "xa15a2ab7--e9c226--service-logo",
  "key": "xa15a2ab7--e9c226--key",
  "main": "xa15a2ab7--e9c226--main",
  "buttons": "xa15a2ab7--e9c226--buttons",
};

module.exports = exports;
